@switch (variant()) {
  @case ('mandatory') {
    {{ 'addToCart.cart.accessories.mandatory' | transloco }}
  }
}
